import { Controller } from 'stimulus';
import setCookie from '../helpers/setCookie';
import dataLayerHelper from '../helpers/dataLayer';
import toArray from '../helpers/toArray';

class LanguageBar extends Controller {
  onDismiss() {
    this.element.style.opacity = '0';
    this.element.style.visibility = 'hidden';
    this.element.style.position = 'absolute';

    setCookie(this.data.get('dismissed-cookie-name'), 1, 365);

    dataLayerHelper.event('Language bar', 'close');
  }

  onSwitch(event) {
    const toIsoCode = this.data.get('switch-to');

    dataLayerHelper.event('Language bar', 'switch', toIsoCode);

    const toUrl = this.findUrlForLanguage(toIsoCode);

    if (toUrl) {
      event.preventDefault();
      window.location.href = toUrl;
    }
  }

  // eslint-disable-next-line class-methods-use-this
  findUrlForLanguage(language) {
    const links = toArray(document.querySelectorAll('[rel="alternate"]'));

    const linksForLanguage = links.filter((link) => (
      link.getAttribute('hreflang') === language
    ));

    return linksForLanguage.length ? linksForLanguage[0].href : null;
  }
}

LanguageBar.targets = [
  //
];

export default LanguageBar;
